export const servizi = [
  {"name":"Animali ammessi (con supplemento)",
  "id":"fa fa-dog",
  "isPagamento":true,
  "categoria":"Animali"
},
  {
  "name":"Biancheria da letto",
  "id":"fa fa-whiteness-bed",
  "isPagamento":false,
  "categoria":"Biancheria"
},
  {
    "name":"Biancheria per la casa",
    "id":"fa fa-whiteness-home",
    "isPagamento":false,"categoria":"Biancheria"
  },
  {
    "name":"Biancheria da letto (a pagamento)",
    "id":"fa fa-whiteness-bed",
    "isPagamento":true,
    "categoria":"Biancheria"
},
{
  "name":"Biancheria per la casa (a pagamento)",
  "id":"fa fa-whiteness-home",
  "isPagamento":true,
  "categoria":"Biancheria"
},
{"name":"Noleggio culla (a pagamento)",
"id":"fa fa-baby-carriage",
"isPagamento":true,
"categoria":"Camera da Letto"
},
{"name":"Tv","id":"fa fa-tv",
"isPagamento":false,
"categoria":"Elettronica"}
,
{"name":"Piscina",
"id":"fa fa-water",
"isPagamento":false,
"categoria":"Esterno"},
{"name":"Giardino",
"id":"fa fa-garden",
"isPagamento":false,
"categoria":"Esterno"},
{"name":"Utilizzo barbecue ",
"id":"fa fa-grill",
"isPagamento":false,
"categoria":"Esterno"},
{"name":"Terrazza",
"id":"fa fa-terrace",
"isPagamento":false,
"categoria":"Esterno"},
{"name":"Balcone",
"id":"fa fa-balcony",
"isPagamento":false,
"categoria":"Esterno"},
{"name":"Docce esterne",
"id":"fa fa-shower",
"isPagamento":false,
"categoria":"Esterno"},
{"name":"Ascensore",
"id":"fa fa-elevator",
"isPagamento":false,
"categoria":"Esterno"},
{"name":"Parcheggio gratuito non custodito",
"id":"fa fa-square-parking",
"isPagamento":false,
"categoria":"Esterno"},
{"name":"Noleggio bici (a pagamento)",
"id":"fa fa-bicycle",
"isPagamento":true,
"categoria":"Esterno"
},
{"name":"Parcheggio non custodito (a pagamento)",
"id":"fa fa-square-parking",
"isPagamento":true,"categoria":"Esterno"
},
{"name":"Asciugatrice","id":"fa fa-dryer",
"isPagamento":false,"categoria":"Lavanderia"
},
{"name":"Ferro da stiro",
"id":"fa fa-iron",
"isPagamento":false,
"categoria":"Lavanderia"
},
{"name":"Asse da stiro",
"id":"fa fa-iron-board",
"isPagamento":false,"categoria":"Lavanderia"
},
{"name":"Ferro e asse da stiro","id":"fa fa-iron-board-all","isPagamento":false,"categoria":"Lavanderia"},{"name":"Stendibiancheria","id":"fa fa-clothesline","isPagamento":false,"categoria":"Lavanderia"},{"name":"Lavatrice","id":"fa fa-washing-machine","isPagamento":false,"categoria":"Lavanderia\n"},{"name":"Divano-letto","id":"fa fa-sofa-bed","isPagamento":false,"categoria":"Mobili"},{"name":"Cucina","id":"fa fa-knife-kitchen","isPagamento":false,"categoria":"Oggetti Cucina"},{"name":"Forno","id":"fa fa-oven","isPagamento":false,"categoria":"Oggetti Cucina"},{"name":"Forno a microonde","id":"fa fa-microwave","isPagamento":false,"categoria":"Oggetti Cucina"},{"name":"Frigorifero","id":"fa fa-refrigerator","isPagamento":false,"categoria":"Oggetti Cucina"},{"name":"Macchina caffè","id":"fa fa-mug-saucer","isPagamento":false,"categoria":"Oggetti Cucina"},{"name":"Stovigle","id":"fa fa-stovigles","isPagamento":false,"categoria":"Oggetti Cucina"},{"name":"Lavastoviglie","id":"fa fa-dish-washers","isPagamento":false,"categoria":"Oggetti Cucina"},{"name":"Pentole","id":"fa fa-pentole","isPagamento":false,"categoria":"Oggetti Cucina"},{"name":"Utensili per la cucina","id":"fa fa-utensils","isPagamento":false,"categoria":"Oggetti Cucina"},{"name":"Prodotti da bagno in omaggio","id":"fa fa-bathroom","isPagamento":false,"categoria":"Oggetti per il bagno"},{"name":"Carta igienica","id":"fa fa-toilet-paper","isPagamento":false,"categoria":"Oggetti per il bagno"},{"name":"Asciugamani ","id":"fa fa-towels","isPagamento":false,"categoria":"Oggetti per il bagno"},{"name":"Asciugamani (a pagamento)","id":"fa fa-towels","isPagamento":true,"categoria":"Oggetti per il bagno"},{"name":"Prodotti per le pulizie","id":"fa fa-temperature-full","isPagamento":false,"categoria":"Pulizie"},{"name":"Aria climatizzata","id":"fa fa-air-condition","isPagamento":false,"categoria":"Relax"},{"name":"Internet WiFi ","id":"fa fa-wifi","isPagamento":false,"categoria":"Relax"},{"name":"Riscaldamento","id":"fa fa-heating","isPagamento":false,"categoria":"Relax"},{"name":"Aria climatizzata (a pagamento)","id":"fa fa-air-condition","isPagamento":true,"categoria":"Relax"},{"name":"Navetta da/per la stazione (a pagamento)","id":"fa fa-van-shuttle","isPagamento":true,"categoria":"Servizi di navetta"},{"name":"Navetta aeroportuale (a pagamento)","id":"fa fa-van-shuttle","isPagamento":true,"categoria":"Servizi di navetta"},{"name":"Cassaforte","id":"fa fa-cassaforte","isPagamento":false,"categoria":"sicurezza"},{"name":"Colazione inclusa nel prezzo","id":"da inserire","isPagamento":"FALSO","categoria":"Relax"}]